import { CloseIcon } from 'assets/icons/CloseIcon'
import CalendarInput from 'components/CalendarInput/CalendarInput'
import { HonestSelectInput } from 'components/HonestSelect/HonestSelectInput'
import { Input } from 'components/Input/Input'
import { Modal } from 'components/Modal/Modal'
import { Button } from 'components/ui/Button/Button'
import { ISelectValue } from 'constants/globalTypes'
import { format, parseISO } from 'date-fns'
import useModalClose from 'hooks/useModalClose'
import { useState } from 'react'
import { CursorPointer, Flex } from 'styling/GlobalStyles'
import { TitleText } from 'styling/Typography'
import { IFuelDipEntryState, IFuelDipSavePayload } from 'types/fuelReconciliation.interface'
import useFocusFirstInput from 'utils/useFocusFirstInput'

export const EnterDipModal = ({
    closeModal,
    tankOptions,
    defaultTankId,
    defaultDateISO,
    onSave,
}: {
    closeModal: any
    tankOptions: ISelectValue[]
    defaultTankId: number | null
    defaultDateISO: string
    onSave: (payload: IFuelDipSavePayload) => void
}) => {
    const [state, setState] = useState<IFuelDipEntryState>({
        tank: tankOptions.find((option) => option.value === defaultTankId) || null,
        date: parseISO(defaultDateISO),
        openingDipL: null,
        closingDipL: null,
    })
    useFocusFirstInput()
    useModalClose(closeModal)

    const handleNumber = (e: React.ChangeEvent<HTMLInputElement>) => {
        setState({ ...state, [e.target.name]: e.target.value === '' ? null : Number(e.target.value) })
    }

    const invalid =
        !state.tank || !state.date || state.openingDipL == null || state.closingDipL == null

    const handleSave = () => {
        if (invalid) return
        onSave({
            tankId: Number(state.tank.value),
            dateISO: format(state.date, 'yyyy-MM-dd'),
            openingDipL: state.openingDipL,
            closingDipL: state.closingDipL,
        })
        closeModal()
    }

    return <Modal black>
        <Flex column between center>
            <Flex column gap='1rem' width='100%'>
                <Flex between width='100%' center style={{ marginBottom: '1rem' }}>
                    <TitleText weight='bold'>Enter dip</TitleText>
                    <CursorPointer onClick={closeModal}>
                        <CloseIcon />
                    </CursorPointer>
                </Flex>
                <HonestSelectInput
                    labelText='Tank'
                    name='tank'
                    options={tankOptions}
                    defaultValue={state.tank?.value}
                    onChange={(value: ISelectValue) => setState({ ...state, tank: value })}
                    nomarg
                    required
                    invalid={!state.tank}
                />
                <CalendarInput
                    labelText='Day'
                    name='dipDate'
                    defaultValue={state.date}
                    maxDate={new Date()}
                    onChange={(date: Date | null) => setState({ ...state, date })}
                    nomarg
                    required
                />
                <Flex gap='1rem'>
                    <Input
                        placeholder='5450...'
                        labelText='Opening dip (L)'
                        name='openingDipL'
                        type='number'
                        value={state.openingDipL}
                        onChange={handleNumber}
                        nomarg
                        required
                        invalid={state.openingDipL == null}
                        allowZero
                    />
                    <Input
                        placeholder='3600...'
                        labelText='Closing dip (L)'
                        name='closingDipL'
                        type='number'
                        value={state.closingDipL}
                        onChange={handleNumber}
                        nomarg
                        required
                        invalid={state.closingDipL == null}
                        allowZero
                    />
                </Flex>
            </Flex>
            <Button style={{ marginTop: '1rem' }} disabled={invalid} variant='primary' onClick={handleSave}>Save</Button>
        </Flex>
    </Modal>
}
